export enum SelectionButtonEnum {
  SenderTypes = 'SENDER_TYPES',
  Days = 'DAYS',
  FirstMessageDay = 'FirstMessageDay',
  Time = 'TIME',
}
